/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { ButtonProps as ReactFormButtonProps, useFormContext } from '@jalik/react-form'
import { Button, ButtonProps } from '@mantine/core'

export type FormButtonProps = ButtonProps & ReactFormButtonProps<'button'>

function FormButton (props: FormButtonProps) {
  const { children, ...others } = props
  const { getButtonProps } = useFormContext()
  return (
    <Button {...getButtonProps(others)}>
      {children}
    </Button>
  )
}

export default FormButton
